import { Component, HostBinding, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-enfaf-textarea-light',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, FormsModule],
  templateUrl: './enfaf-textarea-light.component.html',
  styleUrl: './enfaf-textarea-light.component.scss'
})
export class EnfafTextareaLightComponent {
  @Input() control!: any;
  @Input() placeholder!: string;
  @Input() title?: string;
  @Input() expandable: boolean = true;
  @Input() width?: number;
  @Input() height?: number;
  @Input() rows: number = 3;
  @Input() cols: number = 1;
  @Input() maxLength?: number | null;
  @Input() maxlength?: number | null;
  @Input() autocomplete: 'off' | 'on' = 'off';
  @Input() disabled: boolean = false;
  @Input() label!: string;
  @Input() errorLabel!: string;
  @Input() description?: string;
  @Input() hideErrors: boolean = false;

  @HostBinding('class.hide-errors')
  get shouldHideErrors() {
    return this.hideErrors;
  }

  get hasValue() {
    return this.control && this.control.value !== null && this.control.value !== '';
  }

  get effectiveMaxLength(): number | null {
    return this.maxLength ?? this.maxlength ?? null;
  }

  get responsiveWidth(): string | null {
    if (!this.width) return null;
    return `min(${this.width}px, 100%)`;
  }
}
